const ForImages = ({ images }) => {
  return (
    <div className="relative flex justify-center gap-x-4 px-0 md:px-10 pt-10 pb-0 md:pb-10 max-w-full md:max-w-[500px] h-[300px] md:h-[400px]">
      <div className="space-y-4 flex flex-col items-end">
      <div className="relative w-[80%] md:w-full h-full max-h-[154px] rounded-xl overflow-hidden">
        <img
          src={images[0].url}
          alt="Image1"
          className="object-cover"
        />
      </div>
      <div className="relative w-[80%] md:w-full h-full max-h-[154px] rounded-xl overflow-hidden">
        <img
          src={images[2].url}
          alt="Image2"
          className="object-cover"
        />
      </div>
      </div>
      <div className="space-y-4 -mt-[35px] flex flex-col items-start">
        <div className="relative w-[80%] md:w-full h-full max-h-[154px] rounded-xl overflow-hidden">
          <img
            src={images[1].url}
            alt="Image3"
            className="object-cover"
          />
        </div>
        <div className="relative w-[80%] md:w-full h-full max-h-[154px] rounded-xl overflow-hidden">
          <img
            src={images[3].url}
            alt="Image4"
            className="object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default ForImages;